import { useState } from 'react';
import SectionHead from './SectionHead';
import { faq } from '@/mocks/meihei';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="anchor-target bg-paper py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHead
          center
          eyebrow="常见疑问 · FAQ"
          title="关于「吃瓜姿势」的四个高频问题"
          desc="评论区里被反复追问的细节，这里一次性给到参考答案。"
        />

        <div className="mt-10 divide-y divide-line rounded-xl border border-line bg-cream/40">
          {faq.map((item, i) => {
            const active = open === i;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpen(active ? null : i)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-[14px] font-bold leading-snug text-ink md:text-[15px]">
                    <span className="mr-2 font-display text-sm text-ember-500">Q{i + 1}</span>
                    {item.q}
                  </h3>
                  <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-colors ${active ? 'bg-ember-500 text-white' : 'bg-paper text-ink'}`}>
                    <i className={`ri-${active ? 'subtract' : 'add'}-line`} aria-hidden="true"></i>
                  </span>
                </button>
                <div className={`grid transition-all ${active ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[3.25rem] text-[13px] leading-relaxed text-clay">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-center text-[13px] text-clay">
          <i className="ri-settings-3-line text-ember-500" aria-hidden="true"></i>
          页面为静态展示，点击与折叠仅作示意，不接入真实提交或接口。
        </p>
      </div>
    </section>
  );
}